export default "__VITE_ASSET__DTFALgyQ__"